import { ImgHTMLAttributes, TableHTMLAttributes, useMemo } from "react";
import { Cards, Card } from "./Cards";
import ZoomableImage from "../zoomable-image";
import { AnyObject } from "@/types/common";

const regex = /\s*\[#(?<slug>[^]+?)]\s*$/;

function HeadComponent(headingElement: string, props: AnyObject) {
  const Component = useMemo(() => {
    switch (headingElement) {
      case 'h1': return (props: AnyObject) => <h1 {...props} />;
      case 'h2': return (props: AnyObject) => <h2 {...props} />;
      case 'h3': return (props: AnyObject) => <h3 {...props} />;
      case 'h4': return (props: AnyObject) => <h4 {...props} />;
      case 'h5': return (props: AnyObject) => <h5 {...props} />;
      case 'h6': return (props: AnyObject) => <h6 {...props} />;
      default: return (props: AnyObject) => <h1 {...props} />;
    }
  }, [headingElement]);

  const text = useMemo(() => {
    // Replace the markdown heading prefix with an empty string
    return props.children.replace(regex, '');
  }, [props.children]);

  return <Component {...props}>{text}</Component>
}

function Table(
  props: TableHTMLAttributes<HTMLTableElement>,
): React.ReactElement {
  return (
    <div className="relative overflow-auto">
      <table className="table-auto" {...props} />
    </div>
  );
}

const components = {
  h1: (props: AnyObject) => HeadComponent('h1', props),
  h2: (props: AnyObject) => HeadComponent('h2', props),
  h3: (props: AnyObject) => HeadComponent('h3', props),
  h4: (props: AnyObject) => HeadComponent('h4', props),
  h5: (props: AnyObject) => HeadComponent('h5', props),
  h6: (props: AnyObject) => HeadComponent('h6', props),
  Cards,
  Card,
  table: Table,
  img: (props: ImgHTMLAttributes<HTMLImageElement>) => (
    <span className="w-full block rounded-xl bg-gradient-to-br from-pink-500 to-blue-500 p-4 prose-no-margin">
      {/* <img {...props} className="!my-0 rounded-xl bg-fd-background" /> */}
      <ZoomableImage {...props} />
    </span>
  ),
  // img: (props: any) => {
  //   console.log(props);
  //   return <img {...props} src={`https://docs.viberuzenetek.hu${props.src.replace('.png', '.webp')}`} />;
  // },
};

export default components;
